import React from "react";
import LoginOld from "./LoginOld";
import Perfil from "./Perfil";
import Ofertas from "./Ofertas";
import Validacion from "./Validacion";
import Alertas from "./Alertas";
import Bienvenida from "./Bienvenida";
import Postulaciones from "./Postulaciones";
import Notificaciones from "./Notificaciones";
import { BrowserRouter as Router, Route } from "react-router-dom";
import { Login } from "./Login/Login";

export default class Inicial extends React.Component {
  constructor(props) {
    super(props);
    this.state = { combos: null };
  }

  render() {
    return (
      <div className="ARC_Inicial">
        <Router basename={'/'} >

          <Route
            render={({ location, history }) => (
              <div className="App_Content">

                <div className="App_MDV Hide_All">
                  <button
                    id="Id_login"
                    onClick={(sl) => {
                      var to = `${process.env.PUBLIC_URL}/login`;// x;
                      if (to !== null) {
                        history.push(to);
                      }
                    }}
                  >
                    login
                  </button>
                  <button
                    id="Id_valida"
                    onClick={(sl) => {
                      var to = `${process.env.PUBLIC_URL}/valida`;// x;
                      if (to !== null) {
                        history.push(to);
                      }
                    }}
                  >
                    valida
                  </button>
                  <button
                    id="Id_olvidada"
                    onClick={(sl) => {
                      var to = `${process.env.PUBLIC_URL}/olvidada`;// x;
                      if (to !== null) {
                        history.push(to);
                      }
                    }}
                  >
                    olvidada
                  </button>
                  <button
                    id="Id_Registrarse"
                    onClick={(sl) => {
                      var to = `${process.env.PUBLIC_URL}/registrarse`;//x;
                      if (to !== null) {

                        history.push(to);
                      }
                    }}
                  >
                    registrarse
                  </button>
                  <button
                    id="Id_ofertas"
                    onClick={(sl) => {
                      var to = `${process.env.PUBLIC_URL}/ofertas`;// x;
                      if (to !== null) {

                        history.push(to);
                      }
                    }}
                  >
                    ofertas
                  </button>
                  <button
                    id="Id_perfil"
                    onClick={(sl) => {
                      var to = `${process.env.PUBLIC_URL}/perfil`;//x;
                      if (to !== null) {

                        history.push(to);
                      }
                    }}
                  >
                    perfil
                  </button>
                  <button
                    id="Id_postulaciones"
                    onClick={(sl) => {
                      var to = `${process.env.PUBLIC_URL}/postulaciones`;//x;
                      if (to !== null) {

                        history.push(to);
                      }
                    }}
                  >
                    postulaciones
                  </button>
                  <button
                    id="Id_alertas"
                    onClick={(sl) => {
                      var to = `${process.env.PUBLIC_URL}/alertas`;// x;
                      if (to !== null) {

                        history.push(to);
                      }
                    }}
                  >
                    alertas
                  </button>
                  <button
                    id="Id_notificaciones"
                    onClick={(sl) => {
                      var to = `${process.env.PUBLIC_URL}/notificaciones`;
                      if (to !== null) {

                        history.push(to);
                      }
                    }}
                  >
                    notificaciones
                  </button>
                </div>

                <main className="App_Menu_Content">
                  <Route
                    path={`${process.env.PUBLIC_URL}/`}
                    exact
                    component={props => <Bienvenida />}
                  />
                  <Route
                    path={`${process.env.PUBLIC_URL}/login`}
                    component={props => <Login />}
                  />
                  <Route
                    path={`${process.env.PUBLIC_URL}/olvidada`}
                    component={props => <LoginOld accion={"olvidada"} />}
                  />
                  <Route
                    path={`${process.env.PUBLIC_URL}/registrarse`}
                    component={props => <LoginOld accion={"new"} />}
                  />
                  <Route
                    path={`${process.env.PUBLIC_URL}/cambiarContrasena/:id`}
                    component={props => <LoginOld accion={"cambiarContrasena"} id={props.match.params.id} />}
                  />
                  <Route
                    path={`${process.env.PUBLIC_URL}/valida/:mail`}
                    component={props => <LoginOld accion={"valida"} mail={props.match.params.mail} />}
                  />
                  <Route
                    path={`${process.env.PUBLIC_URL}/ofertas`}
                    component={props => <Ofertas combos={this.state.combos} />}
                  />
                  <Route
                    path={`${process.env.PUBLIC_URL}/perfil`}
                    component={props => <Perfil />}
                  />
                  <Route
                    path={`${process.env.PUBLIC_URL}/postulaciones`}
                    component={props => <Postulaciones />}
                  />
                  <Route
                    path={`${process.env.PUBLIC_URL}/alertas`}
                    component={props => <Alertas />}
                  />
                  <Route
                    path={`${process.env.PUBLIC_URL}/notificaciones`}
                    component={props => <Notificaciones />}
                  />
                  <Route
                    path={`${process.env.PUBLIC_URL}/Validacion`}
                    component={props => <Validacion />}
                  />
                </main>
              </div>
            )}
          />
        </Router>
      </div>
    );
  }
}
